/**
 * Internal dependencies
 */
import Request from './lib/util/request';
import requestHandler from './lib/util/fetch-request';
import SupportPlan from './lib/support-plan';
import RetailerRentalPlan from './lib/retailer-rental-plan';
import RentalPlan from './lib/rental-plan';
import Subscription from './lib/subscription';
import Invoice from './lib/invoice';
import PaymentMethod from './lib/payment-method';
import HostedPage from './lib/hosted-page';
import CurrentSupport from './lib/current-support';
import CurrentRental from './lib/current-rental';
import CurrentRetailerRental from './lib/current-retailer-rental';
import CurrentWeb from './lib/current-web';
import WebPlan from './lib/web-plan';
import DispatchPlan from './lib/dispatch-plan';
import BarcodeLookupPlan from './lib/barcode-lookup-plan';
import CurrentBarcodeLookup from './lib/current-barcode-lookup';
import CurrentCloudHosting from './lib/current-cloud-hosting';
import CloudBackupPlan from './lib/cloud-backup-plan';
import CurrentCloudBackup from './lib/current-cloud-backup';
import Authentication from './lib/authentication';
import User from './lib/user';
import Addon from './lib/addon';
import Coupon from './lib/coupon';
import Estimate from './lib/estimate';
import RoamPlan from './lib/roam-plan';
import CurrentRoam from './lib/current-roam';
import CurrentTsPay from './lib/current-tspay';
import PlanNames from './lib/plan-names';
import KioskPlan from './lib/kiosk-plan';
import VisualDeckPlan from './lib/visual-deck-plan';
import CurrentVisualDeck from './lib/current-visual-deck';
import UniversalImporterPlan from './lib/universal-importer-plan';
import CurrentUniversalImporter from './lib/current-universal-importer';
import AccountMessage from './lib/account-message';
import Version from './lib/version';

function CSCOM(token) {
    if (!(this instanceof CSCOM)) {
        return new CSCOM(token);
    }

    this.request = function(params, fn) {
        params = params || {};
        // token is optional
        if (this.token) {
            params.authToken = this.token;
        }

        return requestHandler(params, fn);
    };

    // Add Req instance
    this.req = new Request(this);
}

CSCOM.prototype.authentication = function() {
    return new Authentication(this);
};

CSCOM.prototype.addon = function() {
    return new Addon(this);
};

CSCOM.prototype.coupon = function() {
    return new Coupon(this);
};

CSCOM.prototype.estimate = function() {
    return new Estimate(this);
};

CSCOM.prototype.supportPlan = function() {
    return new SupportPlan(this);
};

CSCOM.prototype.rentalPlan = function() {
    return new RentalPlan(this);
};

CSCOM.prototype.retailerRentalPlan = function() {
    return new RetailerRentalPlan(this);
};

CSCOM.prototype.subscription = function() {
    return new Subscription(this);
};

CSCOM.prototype.invoice = function() {
    return new Invoice(this);
};

CSCOM.prototype.paymentMethod = function() {
    return new PaymentMethod(this);
};

CSCOM.prototype.hostedPage = function() {
    return new HostedPage(this);
};

CSCOM.prototype.currentSupport = function() {
    return new CurrentSupport(this);
};

CSCOM.prototype.currentRental = function() {
    return new CurrentRental(this);
};

CSCOM.prototype.currentRetailerRental = function() {
    return new CurrentRetailerRental(this);
};

CSCOM.prototype.currentCloudHosting = function() {
    return new CurrentCloudHosting(this);
};

CSCOM.prototype.currentWeb = function() {
    return new CurrentWeb(this);
};

CSCOM.prototype.webPlan = function() {
    return new WebPlan(this);
};

CSCOM.prototype.user = function() {
    return new User(this);
};

// CSCOM.prototype.currentDispatch = function() {
//     return new CurrentDispatch(this);
// };

CSCOM.prototype.dispatchPlan = function() {
    return new DispatchPlan(this);
};

CSCOM.prototype.currentCloudBackup = function() {
    return new CurrentCloudBackup(this);
};

CSCOM.prototype.cloudBackupPlan = function() {
    return new CloudBackupPlan(this);
};

CSCOM.prototype.barcodeLookupPlan = function() {
    return new BarcodeLookupPlan(this);
};

CSCOM.prototype.currentBarcodeLookup = function() {
    return new CurrentBarcodeLookup(this);
};

CSCOM.prototype.currentRoam = function() {
    return new CurrentRoam(this);
};

CSCOM.prototype.roamPlan = function() {
    return new RoamPlan(this);
};

CSCOM.prototype.currentTsPay = function() {
    return new CurrentTsPay(this);
};

CSCOM.prototype.planNames = function() {
    return new PlanNames(this);
};

CSCOM.prototype.kioskPlan = function() {
    return new KioskPlan(this);
};

CSCOM.prototype.currentVisualDeck = function() {
    return new CurrentVisualDeck(this);
};

CSCOM.prototype.visualDeckPlan = function() {
    return new VisualDeckPlan(this);
};

CSCOM.prototype.currentUniversalImporter = function() {
    return new CurrentUniversalImporter(this);
};

CSCOM.prototype.universalImporterPlan = function() {
    return new UniversalImporterPlan(this);
};

CSCOM.prototype.accountMessage = function() {
    return new AccountMessage(this);
};

CSCOM.prototype.version = function() {
    return new Version(this);
};

CSCOM.Request = Request;

let cscom;

if (!cscom) {
    cscom = CSCOM();
}

export default cscom;